// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"0357ea32","940":"aef99074"}[chunkId] + ".chunk.css";
};